import { getEnvironment, ToastEnvironment } from './getEnvironment'

export function getCurrentEnvironment(url: string = ''): ToastEnvironment {
  const urlToUse = url || window.location.hostname
  return getEnvironment(urlToUse)
}
